module.exports = __webpack_public_path__ + "static/media/store.d9c007b3.png";